
export function sortFn(a: any, b: any): number {
  return a === b ? 0 : a < b ? -1 : 1;
}